<div class="occupied-places-legend">
    <h2 class="title">Занятое место</h2>
    <div class="legends">
        @for (legend of legends; track legend) {
            <ng-container *ngTemplateOutlet="legendTemplate; context: { legend: legend }"></ng-container>
        }
    </div>
</div>

<ng-template #legendTemplate let-legend="legend">
    <div class="blank-container">
        <div class="blank" [style.background]="legend.background"></div>
        <span class="text">{{ legend.text }}</span>
    </div>
</ng-template>
